export default "__VITE_ASSET__VPx17__1__"